
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipos/laliga/[slug]/alineaciones-probables",
      function () {
        return require("private-next-pages/equipos/laliga/[slug]/alineaciones-probables.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipos/laliga/[slug]/alineaciones-probables"])
      });
    }
  